import cn from 'classnames';

import ArticleRelatedData from './ArticleRelatedData';
import PageHeaderWrapper from '@/creditflowresearch/ui/common/components/PageHeaderWrapper';
import MissingSomethingModalButton from '@/creditflowresearch/ui/common/components/MissingSomethingModalButton';
import ArticleContent from './ArticleContent';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';
import NoAccessOverlayArticles from '@/creditflowresearch/ui/components/creditFlow/common/NoAccessOverlayArticles';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { UserPlanFeature } from '@creditflowresearch/user-plan/vo/IUserPlanResponse';
import { useArticleContext } from '@/creditflowresearch/application/ArticlesAndStats/Article';
import { useAccessGrant } from '@/creditflowresearch/application/User/access/grants/useAccessGrant';

import cardStyles from '@creditflowresearch/uilib/styles/card.module.scss';
import styles from '../common/styles.module.scss';

const Article = () => {
  const {
    checkAccessByUserPlan,
    checkAccessByFeature,
  } = useUserPlanContext();
  const { article: { noAccess } } = useArticleContext();
  const granted = useAccessGrant();
  const checks = [
    !noAccess,
    granted || checkAccessByUserPlan(UserPlanType.PREMIUM),
    granted || checkAccessByFeature(UserPlanFeature.CommentaryAndDealFlow),
  ];

  return (
    <>
      <PageHeaderWrapper title="Commentary & Deal Flow" />
      <CheckUserAccess conditions={ [{ checks, fallback: <NoAccessOverlayArticles /> }] }>
        <>
          <div className={ cn(cardStyles.cardContainer, styles.creditFlowWrapper) }>
            <ArticleRelatedData />
            <ArticleContent />
          </div>
          <MissingSomethingModalButton />
        </>
      </CheckUserAccess>
    </>
  );
};

export default Article;
